<template>
  <v-container>
    <page-header :title="lang.genres" :info="lang.genresInfo" />
    <div hidden v-html="`${lang.genres}, ${lang.genresInfo}`" :class="['meta-description']" />
    <v-card :class="['elevation-1']">
      <v-list :class="['mx-2']">
        <v-list-tile :to="`/genres/${genre.id}`" v-for="genre in genres" :title="lang.moreInfoAboutTheBandsInGenre(genre.label)" :key="genre.label">
          <v-list-tile-action>
            <v-icon>mdi-guitar-electric</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="genre.label" />
          </v-list-tile-content>
          <chevron-right />
        </v-list-tile>
      </v-list>
    </v-card>
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'genres',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      genres: []
    }
  },
  mounted () {
    this.genres = this.$root.genres
    this.$nextTick(() => {
      this.emitRouteChange()
      this.setLastBreadcrumbsItemText(this.lang.genres)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/genres.vue